export default function deleteCouponReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'DELETE_COUPON_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DELETE_COUPON_ERROR':
            return {...state, ...{error: action.error}};

        case 'DELETE_COUPON_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}